import { API } from "../../api";
async function client_terms(request) {
    // console.log("client_terms -> request", request);
    return await new API().apiGet({
        baseUrl: process.env.LETS_TRADE_CLIENT_URL ?? "",
        endpoint: `/v2/client/terms`,
        authorization: process.env.LETS_TRADE_CLIENT_TOKEN,
    });
}
export { client_terms };
